export default __webpack_public_path__ + "static/media/avatr_2.e9d833f9.jpg";